<template>
    <!-- 云环境管理的子网详情 -->
    <div class="layout-rctable-container env-mgtvpc"
         style="background:#f5f6f7;height:100%;">
        <helpinfo :helpData="helpData">
            <div slot="slotR"
                 class="back-div"
                 @click="$router.go(-1)">
                <Icon type="ios-arrow-dropleft"
                      size="16" />
                <span>{{$t('返回')}}</span>
            </div>
        </helpinfo>
        <div class="table-container"
             style="background:#f5f6f7;padding:15px;">
            <Tabs style="min-height: 100%;"
                  v-model="tab"
                  type='card'
                  class="gray"
                  :animated="false">
                <TabPane :label="$t('详情')"
                         name="info">
                    <mgtsubnetdetail v-if="tab === 'info'"
                                     :id="id"></mgtsubnetdetail>
                </TabPane>
                <TabPane :label="$t('IP地址管理')"
                         v-if="!envTypeList.includes(envType)"
                         name="ips">
                    <mgtiplist v-if="tab === 'ips' && !['HuaweiCloud','HCSO'].includes(this.envType)"
                               :envId="envId"></mgtiplist>
                    <huaweiiplist v-if="tab === 'ips' && ['HuaweiCloud','HCSO'].includes(this.envType)"
                                  :envId="envId"
                                  :baseInfo="baseInfo"></huaweiiplist>
                </TabPane>
                <TabPane :label="$t('端口')"
                         v-if="envTypeList.includes(envType)"
                         name="ips">
                    <mgtsubnetport v-if="tab === 'ips'"
                                   :id="id"
                                   :envId="envId"
                                   :envType="envType"
                                   :create="create"
                                   :vpcId="vpcId" />
                </TabPane>
            </Tabs>
        </div>
    </div>
</template>

<script>
import helpinfo from '@/views/components/basic/helpinfo.vue'
// import mgtinfo from '@/views/console/vpc/components/mgtinfo.vue'
import mgtsubnetdetail from '@/views/console/vpc/components/mgtsubnetdetail.vue'
import mgtiplist from '@/views/console/vpc/components/mgtiplist.vue'
import huaweiiplist from '@/views/console/vpc/components/huaweiiplist.vue'
import mgtsubnetport from '@/views/console/vpc/components/mgtsubnetport.vue'
import API from '@/service/api.js'
export default {
    name: 'subnetdetail',
    components: {
        helpinfo,
        // mgtinfo,
        mgtiplist,
        huaweiiplist,
        mgtsubnetdetail,
        mgtsubnetport
    },
    data () {
        return {
            helpData: {
                modelName: '子网 - ' + this.$route.query.subnetName,
                type: ''
            },
            envTypeList: ['OpenStack', 'OpenStack-Admin', 'ESCloud', 'ESCloud-Admin', 'CloudOS', 'Nine9Cloud', 'Nine9Cloud-Admin'],
            id: '',
            envId: '',
            envType: '',
            region: '',
            tab: this.$route.query.type ? this.$route.query.type : 'info',
            info: {},
            create: false,
            vpcId: '',
            baseInfo: null
        }
    },
    created () {
        this.id = this.$route.params.id
        this.envId = this.$route.query.envId
        this.envType = this.$route.query.envType
        this.vpcId = this.$route.query.vpcId
        this.init()
    },
    methods: {
        init () {
            // 获取子网详情信息
            this.axios.get(this.urlFormat(API.GET_VPC_SUBNET, false, [this.id])).then(res => {
                this.baseInfo = res
            })
        }
    },
    watch: {
        '$route' (val) {
            this.id = this.$route.params.id
            this.envId = this.$route.query.envId
            this.envType = this.$route.query.envType
            this.region = this.$route.query.region
            this.vpcId = this.$route.query.vpcId
        },
        '$route.query.create' (val) {
            if (val) {
                this.create = true
            } else {
                this.create = false
            }
        }
    }
}
</script>
<style lang="less">
</style>
